import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faKey,
  faPlus,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { UrlCollection } from "../../common/url-collection";
import ShowNotification from "../../components/react-notifications/react-notifications";
import {
  NotificationMessageType,
  DomainAdminSite,
  TokenKey,
  setCookies,
  getCookies,
} from "../../utils/configuration";
import * as viVN from "../../language/vi-VN.json";
import * as accountAction from "../../redux/store/account/account.store";

import "./login.scss";

export default function LoginDesktop(props) {
  const [height, setHeight] = useState({
    minHeight: `${window.innerHeight}px`,
  });
  const [radio, setRadio] = React.useState("KHĐT");
  const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

  const onSubmit = (data) => {
    if (!data) return;
    
    accountAction
      .Login({
        checkUrl: radio,
        email: data.email,
        password: data.password,
        rememberMe: true,
        returnUrl: DomainAdminSite,
      })
      .then(
        (res) => {
          if (res && res.content && res.content.token) {
            setCookies(TokenKey.token, res.content.token);
            window.location.replace(DomainAdminSite);
          } else {
            ShowNotification(
              viVN.Errors.UnableHandleException,
              NotificationMessageType.Error
            );
          }
        },
        (err) => {
          err &&
            err.errorType &&
            ShowNotification(
              viVN.Errors[err.errorType],
              NotificationMessageType.Error
            );
        }
      );
  };
  return (
    <div className="login-page" style={height}>
      <div className="login-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12">
              <FontAwesomeIcon
                icon={faUserCircle}
                className="icon-title text-center w-100"
              />
              <h3 className="title text-center w-100 mt-1">Đăng nhập</h3>
            </div>
            <div className="col-12 form-group mt-4">
              <FontAwesomeIcon icon={faUser} className="icon-input" />
              <input
                type="text"
                name="email"
                className="form-control"
                autoComplete="off"
                placeholder="Email"
                ref={register({
                  required: true,
                  pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                })}
              />
              {errors.email && errors.email.type === "required" && (
                <span className="error">Trường này là bắt buộc</span>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <span className="error">Email không đúng định dạng</span>
              )}
            </div>
            <div className="col-12 form-group">
              <FontAwesomeIcon icon={faKey} className="icon-input" />
              <input
                type="password"
                name="password"
                className="form-control"
                autoComplete="off"
                placeholder="Mật khẩu"
                ref={register({
                  required: true,
                  minLength: 8,
                  pattern: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!-@#$%^&*()_+=[{},<.>/?'";:|]).*$/,
                })}
              />
              {errors.password && errors.password.type === "required" && (
                <span className="error">Trường này là bắt buộc</span>
              )}
              {errors.password && errors.password.type === "minLength" && (
                <span className="error">Mật khẩu tối thiểu 8 ký tự</span>
              )}
              {errors.password && errors.password.type === "pattern" && (
                <span className="error">
                  Có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt
                </span>
              )}
            </div>
            <div className="search-option-box">
            <input type="radio" id="search-place"  name="KHĐT" onChange={(e)=>setRadio(e.target.value)} value="KHĐT"  checked={radio === "KHĐT"} />&nbsp;
              <label htmlFor="search-place">Tài khoản bộ KHĐT&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </label>
              <input type="radio" id="search-planning" name="vplan" onChange={(e)=>setRadio(e.target.value)} value="vplan" checked={radio === "vplan"} />&nbsp;
              <label htmlFor="search-planning">Tài khoản vplan</label>
            </div>
            <div className="col-12 text-center mb-4">
              <button type="submit" className="btn btn-danger w-100">
                Đăng nhập
              </button>
            </div>
            <div className="col-12 text-right">
              <Link
                to={UrlCollection.ForgotPassword}
                className="forgot-password"
              >
                Quên mật khẩu?
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
